import { produce } from 'immer';
import {
  TEMPLATE_EDITOR_INIT,
  TEMPLATE_GET_REQUEST,
  TEMPLATE_GET_SUCCESS,
  TEMPLATE_GET_FAILURE,
  TEMPLATE_SAVE_REQUEST,
  TEMPLATE_SAVE_SUCCESS,
  TEMPLATE_SAVE_FAILURE,
  TEMPLATE_PUBLISH_REQUEST,
  TEMPLATE_PUBLISH_SUCCESS,
  TEMPLATE_PUBLISH_FAILURE,
  TEMPLATE_GET_ITEMCOLLECTIONS_GET_REQUEST,
  TEMPLATE_GET_ITEMCOLLECTIONS_GET_SUCCESS,
  TEMPLATE_GET_ITEMCOLLECTIONS_GET_FAILURE,
  ITEMCOLLECTION_SAVE_SUCCESS,
  TEMPLATE_SELECT_FIELDPOSITIONS,
  TEMPLATE_SELECT_PAGES,
  TEMPLATE_DESELECT_FIELDPOSITIONS,
  TEMPLATE_SELECT_FIELDS,
  TEMPLATE_NAV_TO_FIELD,
  TEMPLATE_SELECT_COLUMNPOSITIONS,
  TEMPLATE_SELECT_ROWPOSITIONS,
  TEMPLATE_SELECT_COLUMNS,
  TEMPLATE_SELECT_FIELDPOSITIONS_IN_RECTANGLE,
  TEMPLATE_SELECT_ALL_FIELDPOSITIONS_ON_PAGE,
  TEMPLATE_SELECT_DATALAYOUTPOSITION,
  TEMPLATE_SELECT_DATALAYOUTSECTION,
  TEMPLATE_SELECT_DATALAYOUTTAB,
  TEMPLATE_UPDATE_NAME,
  TEMPLATE_UPDATE_FIELD_NAME,
  TEMPLATE_UPDATE_FIELD_ROWCOUNT,
  TEMPLATE_UPDATE_FIELD_DATASOURCE,
  TEMPLATE_UPDATE_FIELD_TYPE,
  TEMPLATE_UPDATE_DATALAYOUTPOSITION_PROPERTY,
  TEMPLATE_UPDATE_DATALAYOUTSECTION_PROPERTY,
  TEMPLATE_UPDATE_DATALAYOUTTAB_PROPERTY,
  TEMPLATE_UPDATE_COLUMNPOSITION_PROPERTY,
  TEMPLATE_UPDATE_COLUMN_PROPERTY,
  TEMPLATE_UPDATE_COLUMN_PROPERTY_NAME,
  TEMPLATE_UPDATE_ROWPOSITION_PROPERTY,
  TEMPLATE_UPDATE_PAGES,
  TEMPLATE_UPDATE_THUMBNAILFILEID,
  TEMPLATE_UPDATE_PRINTCONFIGS,
  TEMPLATE_UPDATE_DEFAULTFIELDDISPLAYSETTINGS,
  TEMPLATE_UPDATE_PROPERTY,
  TEMPLATE_UPDATE_DEFAULTFORMNAME,
  TEMPLATE_UPDATE_CUSTOMACTIONS,
  TEMPLATE_UPDATE_COLUMN_FIELDTYPE,
  TEMPLATE_UPDATE_IDENTIFIERFIELDID,
  TEMPLATE_UPDATE_FIELD_PROPERTY,
  TEMPLATE_UPDATE_FIELD_FORMULA,
  TEMPLATE_UPDATE_FIELD_CHECKBOXGROUPITEMS,
  TEMPLATE_UPDATE_FIELD_DROPDOWNITEMS,
  TEMPLATE_UPDATE_PAGE_PROPERTY,
  TEMPLATE_UPDATE_FIELDPOSITION_PROPERTY,
  TEMPLATE_UPDATE_FIELDPOSITION_LINEHEIGHT,
  TEMPLATE_UPDATE_FIELDPOSITION_FONTSIZE,
  TEMPLATE_UPDATE_FIELDPOSITION_DISPLAYTYPE,
  TEMPLATE_UPDATE_FIELDPOSITION_STARTINGROW,
  TEMPLATE_UPDATE_FIELDPOSITION_NUMBEROFROWS,
  TEMPLATE_REMOVE_VIEW,
  TEMPLATE_ADD_VIEW,
  TEMPLATE_ADD_FIELDPOSITION,
  TEMPLATE_UPDATE_SELECTED_FIELDPOSITION_COORDINATES_BY_OFFSET,
  TEMPLATE_UPDATE_FIELDPOSITION_COORDINATES,
  TEMPLATE_UPDATE_FIELDPOSITION_COORDINATES_BY_OFFSET,
  TEMPLATE_UPDATE_COLUMN_MOVE,
  TEMPLATE_ADD_COLUMN,
  TEMPLATE_DELETE_COLUMN,
  TEMPLATE_UPDATE_COLUMNPOSITION_DISPLAYTYPE,
  TEMPLATE_UPDATE_COLUMNPOSITION_HIDDEN,
  TEMPLATE_UPDATE_COLUMNPOSITION_WIDTH,
  TEMPLATE_UPDATE_COLUMNPOSITION_WIDTH_BY_OFFSET,
  TEMPLATE_UPDATE_ROWPOSITION_HEIGHT,
  TEMPLATE_UPDATE_ROWPOSITION_HEIGHT_BY_OFFSET,
  TEMPLATE_MOVE_DATALAYOUTPOSITION,
  TEMPLATE_ADD_DATALAYOUTPOSITION,
  TEMPLATE_MOVE_DATALAYOUTSECTION,
  TEMPLATE_ADD_DATALAYOUTSECTION,
  TEMPLATE_DELETE_DATALAYOUTSECTION,
  TEMPLATE_MOVE_DATALAYOUTTAB,
  TEMPLATE_ADD_DATALAYOUTTAB,
  TEMPLATE_DELETE_DATALAYOUTTAB,
  TEMPLATE_DUPLICATE_DATALAYOUTTAB,
  TEMPLATE_DELETE_SELECTED_ITEMS,
  TEMPLATE_COPY_SELECTED_ITEMS,
  TEMPLATE_PASTE_SELECTED_ITEMS,
  TEMPLATE_REPLICATE_SELECTED_ITEMS,
  TEMPLATE_CLIPBOARD_SET_VISIBLE,
  TEMPLATE_SET_CURRENT_PAGE,
  TEMPLATE_SET_CURRENT_TAB,
  TEMPLATE_CURRENT_VIEW_TAB_INDEX,
  TEMPLATE_AUTOBUILD_LISTVIEW,
  TEMPLATE_CLOSE_ERROR,
  TEMPLATE_CLOSE_ERROR_MESSAGE,
  TEMPLATE_FORMULA_FOCUS,
  TEMPLATE_FORMULA_BLUR,
  TEMPLATE_RECOVER,
  TEMPLATE_UNDO,
  TEMPLATE_REDO,
  TEMPLATE_UPDATE_AUTOTAGS,
  TEMPLATE_UPDATE_NAMEDFUNCTIONS,
  TEMPLATE_SWITCH_ACTIVE_EDITOR,
  TEMPLATE_ADD_BASIC_ELEMENT,
  TEMPLATE_SELECT_BASIC_ELEMENTS,
  TEMPLATE_CLEAR_SELECTION,
  TEMPLATE_REMOVE_BASIC_ELEMENTS,
  TEMPLATE_UPDATE_BASIC_ELEMENTS_PROPERTIES,
  TEMPLATE_UPDATE_BASIC_ELEMENTS_Z_INDEX,
  TEMPLATE_ADD_BASIC_ELEMENT_UPLOAD,
  TEMPLATE_UPDATE_BASIC_ELEMENTS_PROPERTIES_GROUPED_HISTORY,
  TEMPLATE_UPDATE_SELECTED_ITEMS_COORDINATES_BY_OFFSET,
  TEMPLATE_RESET_BASIC_ELEMENT_UPLOADS,
  TEMPLATE_ADD_BASIC_ELEMENTS_ACTION,
  TEMPLATE_EDITOR_INIT_FILES,
  TEMPLATE_UPDATE_BASIC_ELEMENTS_PROPERTIES_SYSTEM_UPDATE,
  TEMPLATE_UPDATE_BASIC_ELEMENTS_GROUP_ALIGN,
  TEMPLATE_EDTIOR_SHOW_FIELDS_WITH_ELEMENTS,
  TEMPLATE_EDITOR_ADD_DRAFT_PAGE_THUMBNAIL,
  TEMPLATE_ADD_FIELD_BEGIN_DRAG,
  TEMPLATE_ADD_FIELD_END_DRAG,
  TEMPLATE_UPDATE_DEFAULT_FIELD_POSITIONS,
  TEMPLATE_UPDATE_FIELD_POSITIONS_USE_DEFAULTS,
  TEMPLATE_UNMAP_SELECTED_ITEMS,
  TEMPLATE_UPDATE_NAME_INPUT_ACCESSED
} from '../actions';
import {
  updateItemCollectionsResetDirty,
  updateSelectedFieldPositions,
  updateSelectedPages,
  deselectFieldPositions,
  updateSelectedFields,
  updateSelectedColumnPositions,
  updateSelectedRowPositions,
  updateSelectedColumns,
  updateSelectedFieldPositionsInRectangle,
  selectAllFieldPositionsOnPage,
  updateSelectedDataLayoutPositions,
  updateSelectedDataLayoutSections,
  updateSelectedDataLayoutTabs,
  updateName,
  updateFieldName,
  updateFieldRowCount,
  updateFieldDataSource,
  updateFieldType,
  updateColumnFieldType,
  updateIdentifierFieldId,
  updateFieldProperty,
  updateFormula,
  updateFieldCheckBoxGroupItems,
  updateFieldDropDownItems,
  updateFieldPositionProperty,
  updateFieldPositionLineHeight,
  updateFieldPositionFontSize,
  updateFieldPositionDisplayType,
  updateFieldPositionStartingRow,
  updateFieldPositionNumberOfRows,
  updateTemplateRemoveView,
  updateTemplateAddView,
  addFieldPosition,
  updateSelectedFieldPositionCoordinates,
  updatedSelectionBoundingRectangle,
  updateFieldPositionCoordinates,
  reorderColumn,
  addColumn,
  deleteColumn,
  updateColumnPositionDisplayType,
  updateColumnPositionHidden,
  updateColumnPositionWidth,
  updateColumnPositionWidthByOffset,
  updateRowPositionHeight,
  updateRowPositionHeightByOffset,
  moveDataLayoutPosition,
  deleteDataLayoutSection,
  addDataLayoutPosition,
  moveDataLayoutSection,
  addDataLayoutSection,
  moveDataLayoutTab,
  addDataLayoutTab,
  deleteDataLayoutTab,
  duplicateDataLayoutTab,
  deleteSelectedItems,
  copySelectedItems,
  duplicateSelectedItems,
  replicateSelectedItems,
  autoBuildListView,
  formulaEditorFocus,
  formulaEditorBlur,
  addBasicElement,
  removeBasicElements,
  updateSelectedBasicElements,
  updateBasicElementsProperties,
  updateBasicElementsZIndex,
  clearSelection,
  updateSelectedObjectsCoordinates,
  addBasicElementUpload,
  resetBasicElementUploads,
  addBasicElementsActions,
  updateBasicElementsGroupAlign,
  updateTemplatePages,
  addDraftPageThumbnail,
  updateFieldPositionsWithDefaultState,
  updateSelectedFieldPositionToUseDefaultState,
  unmapSelectedItems,
  updateTableColumnName,
  updateFieldNameInputVisited,
  navigateToSelectedField,
  setIsDirty
} from '../updaters';
import { updateProperty } from '../utility';
import { TemplateEditorAction, TemplateState } from '../templateeditor-types';
import { mergeDeep } from '../../helpers/utility';
import { EditorTypes } from '../../helpers/constants';
import { aiTemplateBuilderReducer } from '../ai/reducer';
import validationReducer from '../components/FieldValidations/reducer';
import formJourneyReducer from '../components/FormJourney/reducer';

const initialState: TemplateState = {
  isFetching: false,
  isDirty: false,
  initialTemplateJSON: null,
  templateLoaded: false,
  activeEditor: EditorTypes.FieldEditor,
  showFieldsWithElements: false,
  // TODO: this doesn't seem right, default settings are replaced
  //       when they're updated in the template, maybe these should
  //       called 'settings'?
  defaultSettings: {
    checkbox: {},
    default: {},
    esigninitials: {},
    esignsignature: {},
    fileattachment: {},
    gps: {},
    media: {},
    signature: {},
    table: {}
  }
};

export default function templateeditor(existingState: TemplateState = {}, action: TemplateEditorAction) {
  if (!action) return existingState;

  const { type, payload, versionId } = action;

  return produce(existingState, (draftState: TemplateState) => {
    let newState: TemplateState;

    switch (type) {
      case TEMPLATE_EDITOR_INIT:
        return mergeDeep(initialState, payload);

      case TEMPLATE_SAVE_SUCCESS:
        newState = { ...draftState, ...payload };
        newState.template = { ...newState.template, unpublishedChanges: true };
        newState.initialTemplateJSON = JSON.stringify(newState.template);
        return newState;

      case TEMPLATE_PUBLISH_SUCCESS:
        newState = { ...draftState, ...payload };
        newState.template = { ...newState.template, versionId, unpublishedChanges: false };

        return newState;

      case TEMPLATE_EDITOR_INIT_FILES:
      case TEMPLATE_GET_REQUEST:
      case TEMPLATE_GET_SUCCESS:
      case TEMPLATE_GET_FAILURE:
      case TEMPLATE_SAVE_REQUEST:
      case TEMPLATE_SAVE_FAILURE:
      case TEMPLATE_PUBLISH_REQUEST:
      case TEMPLATE_PUBLISH_FAILURE:
      case TEMPLATE_GET_ITEMCOLLECTIONS_GET_REQUEST:
      case TEMPLATE_GET_ITEMCOLLECTIONS_GET_SUCCESS:
      case TEMPLATE_GET_ITEMCOLLECTIONS_GET_FAILURE:
      case TEMPLATE_UNDO:
      case TEMPLATE_REDO:
        return { ...draftState, ...payload };

      case TEMPLATE_RECOVER:
        return { ...draftState, ...payload, isDirty: true };

      case ITEMCOLLECTION_SAVE_SUCCESS:
        return updateItemCollectionsResetDirty(draftState, payload);

      case TEMPLATE_SELECT_FIELDPOSITIONS:
        return updateSelectedFieldPositions(draftState, payload);

      case TEMPLATE_SELECT_PAGES:
        return updateSelectedPages(draftState, payload);

      case TEMPLATE_DESELECT_FIELDPOSITIONS:
        return deselectFieldPositions(draftState, payload);

      case TEMPLATE_SELECT_FIELDS:
        return updateSelectedFields(draftState, payload);

      case TEMPLATE_NAV_TO_FIELD:
        return navigateToSelectedField(draftState, payload);

      case TEMPLATE_SELECT_COLUMNPOSITIONS:
        return updateSelectedColumnPositions(draftState, payload);

      case TEMPLATE_SELECT_ROWPOSITIONS:
        return updateSelectedRowPositions(draftState, payload);

      case TEMPLATE_SELECT_COLUMNS:
        return updateSelectedColumns(draftState, payload);

      case TEMPLATE_SELECT_FIELDPOSITIONS_IN_RECTANGLE:
        return updateSelectedFieldPositionsInRectangle(draftState, payload);

      case TEMPLATE_SELECT_BASIC_ELEMENTS:
        return updateSelectedBasicElements(draftState, payload);

      case TEMPLATE_CLEAR_SELECTION:
        return clearSelection(draftState);

      case TEMPLATE_SELECT_ALL_FIELDPOSITIONS_ON_PAGE:
        return selectAllFieldPositionsOnPage(draftState, payload);

      case TEMPLATE_SELECT_DATALAYOUTPOSITION:
        return updateSelectedDataLayoutPositions(draftState, payload);

      case TEMPLATE_SELECT_DATALAYOUTSECTION:
        return updateSelectedDataLayoutSections(draftState, payload);

      case TEMPLATE_SELECT_DATALAYOUTTAB:
        return updateSelectedDataLayoutTabs(draftState, payload);

      case TEMPLATE_ADD_BASIC_ELEMENT_UPLOAD:
        //This action does not dirty the state. If a true change has happened then one of the fields or elements will have changed and dirty the state
        return addBasicElementUpload(draftState, payload);

      case TEMPLATE_EDITOR_ADD_DRAFT_PAGE_THUMBNAIL:
        return addDraftPageThumbnail(draftState, payload);

      case TEMPLATE_RESET_BASIC_ELEMENT_UPLOADS:
        return setIsDirty(resetBasicElementUploads(draftState, payload));

      case TEMPLATE_UPDATE_NAME:
        return setIsDirty(updateName(draftState, payload));

      case TEMPLATE_UPDATE_FIELD_NAME:
        return setIsDirty(updateFieldName(draftState, payload));

      case TEMPLATE_UPDATE_NAME_INPUT_ACCESSED:
        return updateFieldNameInputVisited(draftState, payload);

      case TEMPLATE_UPDATE_FIELD_ROWCOUNT:
        return setIsDirty(updateFieldRowCount(draftState, payload));

      case TEMPLATE_UPDATE_FIELD_DATASOURCE:
        return setIsDirty(updateFieldDataSource(draftState, payload));

      case TEMPLATE_UPDATE_FIELD_TYPE:
        return setIsDirty(updateFieldType(draftState, payload));

      case TEMPLATE_UPDATE_DATALAYOUTPOSITION_PROPERTY:
      case TEMPLATE_UPDATE_DATALAYOUTSECTION_PROPERTY:
      case TEMPLATE_UPDATE_DATALAYOUTTAB_PROPERTY:
      case TEMPLATE_UPDATE_COLUMNPOSITION_PROPERTY:
      case TEMPLATE_UPDATE_COLUMN_PROPERTY:
      case TEMPLATE_UPDATE_ROWPOSITION_PROPERTY:
      case TEMPLATE_UPDATE_THUMBNAILFILEID:
      case TEMPLATE_UPDATE_PRINTCONFIGS:
      case TEMPLATE_UPDATE_DEFAULTFIELDDISPLAYSETTINGS:
      case TEMPLATE_UPDATE_DEFAULTFORMNAME:
      case TEMPLATE_UPDATE_AUTOTAGS:
      case TEMPLATE_UPDATE_NAMEDFUNCTIONS:
      case TEMPLATE_UPDATE_CUSTOMACTIONS:
      case TEMPLATE_UPDATE_PROPERTY:
      case TEMPLATE_UPDATE_PAGE_PROPERTY:
        return setIsDirty(updateProperty(draftState, payload));

      case TEMPLATE_UPDATE_COLUMN_PROPERTY_NAME:
        return setIsDirty(updateTableColumnName(draftState, payload));

      case TEMPLATE_UPDATE_PAGES:
        return setIsDirty(updateTemplatePages(draftState, payload));

      case TEMPLATE_UPDATE_COLUMN_FIELDTYPE:
        return setIsDirty(updateColumnFieldType(draftState, payload));

      case TEMPLATE_UPDATE_IDENTIFIERFIELDID:
        return setIsDirty(updateIdentifierFieldId(draftState, payload));

      case TEMPLATE_UPDATE_FIELD_PROPERTY:
        return setIsDirty(updateFieldProperty(draftState, payload));

      case TEMPLATE_UPDATE_FIELD_FORMULA:
        return setIsDirty(updateFormula(draftState, action.payload.keyPaths, action.payload.formulaKey, action.payload.formula));

      case TEMPLATE_UPDATE_FIELD_CHECKBOXGROUPITEMS:
        return setIsDirty(updateFieldCheckBoxGroupItems(draftState, payload));

      case TEMPLATE_UPDATE_FIELD_DROPDOWNITEMS:
        return setIsDirty(updateFieldDropDownItems(draftState, payload));

      case TEMPLATE_UPDATE_FIELDPOSITION_PROPERTY:
        return setIsDirty(updateFieldPositionProperty(draftState, payload));

      case TEMPLATE_UPDATE_FIELDPOSITION_LINEHEIGHT:
        return setIsDirty(updateFieldPositionLineHeight(draftState, payload));

      case TEMPLATE_UPDATE_FIELDPOSITION_FONTSIZE:
        return setIsDirty(updateFieldPositionFontSize(draftState, payload));

      case TEMPLATE_UPDATE_FIELDPOSITION_DISPLAYTYPE:
        return setIsDirty(updateFieldPositionDisplayType(draftState, payload));

      case TEMPLATE_UPDATE_FIELDPOSITION_STARTINGROW:
        return setIsDirty(updateFieldPositionStartingRow(draftState, payload));

      case TEMPLATE_UPDATE_FIELDPOSITION_NUMBEROFROWS:
        return setIsDirty(updateFieldPositionNumberOfRows(draftState, payload));

      case TEMPLATE_ADD_BASIC_ELEMENTS_ACTION:
        return setIsDirty(addBasicElementsActions(draftState, payload));

      case TEMPLATE_UPDATE_BASIC_ELEMENTS_PROPERTIES:
        return setIsDirty(updateBasicElementsProperties(draftState, payload));

      case TEMPLATE_UPDATE_BASIC_ELEMENTS_PROPERTIES_SYSTEM_UPDATE:
        return updateBasicElementsProperties(draftState, payload);

      case TEMPLATE_UPDATE_BASIC_ELEMENTS_PROPERTIES_GROUPED_HISTORY:
        return setIsDirty(updateBasicElementsProperties(draftState, payload));

      case TEMPLATE_UPDATE_BASIC_ELEMENTS_GROUP_ALIGN:
        return setIsDirty(updateBasicElementsGroupAlign(draftState, payload));

      case TEMPLATE_UPDATE_BASIC_ELEMENTS_Z_INDEX:
        return setIsDirty(updateBasicElementsZIndex(draftState, payload));

      case TEMPLATE_REMOVE_VIEW:
        return setIsDirty(updateTemplateRemoveView(draftState, payload));

      case TEMPLATE_ADD_VIEW:
        return setIsDirty(updateTemplateAddView(draftState, payload));

      case TEMPLATE_ADD_FIELDPOSITION:
        return setIsDirty(addFieldPosition(draftState, payload));

      case TEMPLATE_ADD_BASIC_ELEMENT:
        return setIsDirty(addBasicElement(draftState, payload));

      case TEMPLATE_REMOVE_BASIC_ELEMENTS:
        return setIsDirty(removeBasicElements(draftState, payload));

      case TEMPLATE_UPDATE_SELECTED_FIELDPOSITION_COORDINATES_BY_OFFSET:
        return setIsDirty(updatedSelectionBoundingRectangle(updateSelectedFieldPositionCoordinates(draftState, payload)));

      case TEMPLATE_UPDATE_SELECTED_ITEMS_COORDINATES_BY_OFFSET:
        return setIsDirty(updatedSelectionBoundingRectangle(updateSelectedObjectsCoordinates(draftState, payload)));

      case TEMPLATE_UPDATE_FIELDPOSITION_COORDINATES:
      case TEMPLATE_UPDATE_FIELDPOSITION_COORDINATES_BY_OFFSET:
        return setIsDirty(updatedSelectionBoundingRectangle(updateFieldPositionCoordinates(draftState, payload)));

      case TEMPLATE_UPDATE_COLUMN_MOVE:
        return setIsDirty(reorderColumn(draftState, payload));

      case TEMPLATE_ADD_COLUMN:
        return setIsDirty(addColumn(draftState, payload));

      case TEMPLATE_DELETE_COLUMN:
        return setIsDirty(deleteColumn(draftState, payload));

      case TEMPLATE_UPDATE_COLUMNPOSITION_DISPLAYTYPE:
        return setIsDirty(updateColumnPositionDisplayType(draftState, payload));

      case TEMPLATE_UPDATE_COLUMNPOSITION_HIDDEN:
        return setIsDirty(updatedSelectionBoundingRectangle(updateColumnPositionHidden(draftState, action.payload.keyPaths, action.payload.value as number)));

      case TEMPLATE_UPDATE_COLUMNPOSITION_WIDTH:
        return setIsDirty(updatedSelectionBoundingRectangle(updateColumnPositionWidth(draftState, action.payload.keyPaths, action.payload.value as number)));

      case TEMPLATE_UPDATE_COLUMNPOSITION_WIDTH_BY_OFFSET:
        return setIsDirty(updatedSelectionBoundingRectangle(updateColumnPositionWidthByOffset(draftState, payload)));

      case TEMPLATE_UPDATE_ROWPOSITION_HEIGHT:
        return setIsDirty(updatedSelectionBoundingRectangle(updateRowPositionHeight(draftState, payload)));

      case TEMPLATE_UPDATE_ROWPOSITION_HEIGHT_BY_OFFSET:
        return setIsDirty(updatedSelectionBoundingRectangle(updateRowPositionHeightByOffset(draftState, payload)));

      case TEMPLATE_MOVE_DATALAYOUTPOSITION:
        return setIsDirty(moveDataLayoutPosition(draftState, payload));

      case TEMPLATE_DELETE_DATALAYOUTSECTION:
        return setIsDirty(deleteDataLayoutSection(draftState, payload));

      case TEMPLATE_ADD_DATALAYOUTPOSITION:
        return setIsDirty(addDataLayoutPosition(draftState, payload));

      case TEMPLATE_MOVE_DATALAYOUTSECTION:
        return setIsDirty(moveDataLayoutSection(draftState, payload));

      case TEMPLATE_ADD_DATALAYOUTSECTION:
        return setIsDirty(addDataLayoutSection(draftState, payload));

      case TEMPLATE_MOVE_DATALAYOUTTAB:
        return setIsDirty(moveDataLayoutTab(draftState, payload));

      case TEMPLATE_ADD_DATALAYOUTTAB:
        return setIsDirty(addDataLayoutTab(draftState, payload));

      case TEMPLATE_DELETE_DATALAYOUTTAB:
        return setIsDirty(deleteDataLayoutTab(draftState, payload));

      case TEMPLATE_DUPLICATE_DATALAYOUTTAB:
        return setIsDirty(duplicateDataLayoutTab(draftState, payload));

      case TEMPLATE_DELETE_SELECTED_ITEMS:
        return setIsDirty(deleteSelectedItems(draftState));

      case TEMPLATE_UNMAP_SELECTED_ITEMS:
        return setIsDirty(unmapSelectedItems(draftState));

      case TEMPLATE_UPDATE_DEFAULT_FIELD_POSITIONS:
        return setIsDirty(updateFieldPositionsWithDefaultState(draftState, payload));

      case TEMPLATE_UPDATE_FIELD_POSITIONS_USE_DEFAULTS:
        return setIsDirty(updateSelectedFieldPositionToUseDefaultState(draftState));

      case TEMPLATE_COPY_SELECTED_ITEMS:
        return copySelectedItems(draftState);

      case TEMPLATE_PASTE_SELECTED_ITEMS:
        return setIsDirty(duplicateSelectedItems(draftState, payload));

      case TEMPLATE_REPLICATE_SELECTED_ITEMS:
        return setIsDirty(replicateSelectedItems(draftState, payload));

      case TEMPLATE_CLIPBOARD_SET_VISIBLE:
        if (!!draftState.clipboard) {
          draftState.clipboard.isVisible = payload.isVisible;
        }

        return draftState;

      case TEMPLATE_SET_CURRENT_PAGE:
        draftState.currentPageId = action.payload.currentPageId;

        return draftState;

      case TEMPLATE_SET_CURRENT_TAB:
        draftState.currentTabKeyPath = action.payload.tabKeyPath;

        return draftState;

      case TEMPLATE_CURRENT_VIEW_TAB_INDEX:
        //if there is no update then don run any updates
        if (draftState.currentTemplateView === action.payload.currentTemplateView) {
          return draftState;
        }

        draftState.currentTemplateView = action.payload.currentTemplateView;
        if (draftState.currentTemplateView != 0) {
          draftState.activeEditor = EditorTypes.FieldEditor;
        }
        //clear the selection when switching view
        return clearSelection(draftState);

      case TEMPLATE_AUTOBUILD_LISTVIEW:
        return setIsDirty(autoBuildListView(draftState));

      case TEMPLATE_CLOSE_ERROR:
        draftState.errorMsg = null;

        return draftState;

      case TEMPLATE_CLOSE_ERROR_MESSAGE:
        if (!!draftState.error) {
          draftState.error.message = null;
        }

        return draftState;

      case TEMPLATE_FORMULA_FOCUS:
        return formulaEditorFocus(draftState, payload);

      case TEMPLATE_FORMULA_BLUR:
        return formulaEditorBlur(draftState);

      case TEMPLATE_SWITCH_ACTIVE_EDITOR:
        draftState.activeEditor = payload.editorType;
        return clearSelection(draftState);

      case TEMPLATE_EDTIOR_SHOW_FIELDS_WITH_ELEMENTS:
        draftState.showFieldsWithElements = payload.showFieldsWithElements;
        return draftState;

      case TEMPLATE_ADD_FIELD_BEGIN_DRAG:
        draftState.addFieldDragging = true;
        return draftState;

      case TEMPLATE_ADD_FIELD_END_DRAG:
        draftState.addFieldDragging = false;
        return draftState;

      default:
        draftState = aiTemplateBuilderReducer(draftState, action);
        draftState = validationReducer(draftState, action);
        draftState = formJourneyReducer(draftState, action);
        return draftState;
    }
  });
}
